import React from "react";

//UI Material
import { Button, TableCell, TableRow, Typography } from "@mui/material";

//Material Icons
import { ArrowForwardIos } from "@mui/icons-material";

export default function DeviceRow({ data }) {
  return (
    <TableRow>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{data.id}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{data.description}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{`${data.brand} ${data.model}`}</Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">
          {new Date(data.createdAt).toLocaleDateString()}
        </Typography>
      </TableCell>
      <TableCell align="center" sx={{ maxWidth: "200px" }}>
        <Typography variant="body2">{data.SIM}</Typography>
      </TableCell>
      <TableCell align="center">
        <Button
          size="small"
          variant="contained"
          color="secondary"
          sx={{ color: "white" }}
          endIcon={<ArrowForwardIos />}
          onClick={() => {
            window.location.href = `/connectivity-device?id=${data.id}`;
          }}
        >
          Ver detalles
        </Button>
      </TableCell>
    </TableRow>
  );
}
